import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#002F77"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#D8FFFF" d="M105.2 40.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#00D8D8"
      d="m71.04 90.21 3.94-3.94c.59-.59.59-1.54 0-2.12s-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12zM19.09 22.59h-5.57v-5.57c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H4.95c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5M34.73 17.97c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path
      fill="#D8FFFF"
      d="M92.94 90.67c-.42-.6-1.29-.62-1.73-.03-1.21 1.64-3.43 4.88-5.09 8.73-2.21 5.11-.89 12.01 6.57 12.01 5.51 0 7.88-6.14 5.46-11.73-1.49-3.43-3.93-7.13-5.2-8.98zM10.07 80.97a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
    <path
      fill="#00D8D8"
      d="M79.3 23.37H48.16a1.32 1.32 0 0 0-1.32 1.32v9.5c0 .73.591 1.32 1.32 1.32H79.3a1.32 1.32 0 0 0 1.32-1.32v-9.5a1.32 1.32 0 0 0-1.32-1.32M26.76 40.88H14.04a1.21 1.21 0 0 0-1.21 1.21V68.2c0 .668.542 1.21 1.21 1.21h12.72a1.21 1.21 0 0 0 1.21-1.21V42.09a1.21 1.21 0 0 0-1.21-1.21"
    />
    <path
      fill="#D8FFFF"
      d="M85.69 46.89h-9.21V35.51H51.46V46.9h-23.5v16.51h25.56c2.24 3.39 6.08 5.63 10.44 5.63s8.21-2.24 10.44-5.63h8.82v7.51h13.64V58.09c0-6.18-5.01-11.19-11.19-11.19z"
    />
    <path
      fill="#00D8D8"
      d="M100.04 70.91H80.07a1.21 1.21 0 0 0-1.21 1.21v9.64c0 .668.542 1.21 1.21 1.21h19.97a1.21 1.21 0 0 0 1.21-1.21v-9.64a1.21 1.21 0 0 0-1.21-1.21"
    />
  </svg>
);
const SvgEnrichedIconPipesBrand = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconPipesBrand);
export default Memo;
